import { Row, Col, Popconfirm } from "antd";
import React from "react";
import CleanButton from "../../../../common/components/CleanButton";
import Page from "../../../../common/components/Page";
import newCivilCase from "../newCivilCase";
import useCivilEFilePayment from "./useCivilEFilePayment";
import PaymentForm from "./paymentForm";
import getConfigs from "../../../../GetConfigs";

const CivilEFilePayment = ({ ...props }) => {
  const { Title, Content } = Page;
  const { feeDue, setIsModalVisible, moneyInCode } = props;
  const { handleMakePayment, paymentTokenLoading, paymentLoader, handleContinue } = useCivilEFilePayment();

    const configurations = getConfigs([
        "activePayProcessor",
        "cvEFilePaymentDisclaimertxt",
        "ctCityName",
    ]);
    function disclaimerText() {
      const customText = configurations?.cvEFilePaymentDisclaimertxt;
      const defaultText = "<Font>The case information contained within this web site is generated from computerized records maintained by "+configurations?.ctCityName+". While every effort is made to assure the data is accurate and current, it must be accepted and used by the recipient with the understanding that no warranties, expressed or implied, concerning the accuracy, reliability or suitability of this data have been made. The Court, Clerk of Court, their agents, and the developers of this web site assume no liability whatsoever associated with the use or misuse of the data contained herein. By accessing or using this Web site, you agree to the terms. </Font>"
      return customText || defaultText;
    }

  return (
    <Page>
      <Title hideBreadcrumb={true} title="Make E-File Payment" icon="money-check-alt" />
      <Content>
        <Row gutter={16}>
          <Col>
            <div dangerouslySetInnerHTML={{ __html: disclaimerText() }} />
            <br/>
            <b>A fee of ${Number(feeDue)?.toFixed(2)} is required for this E-File. Press "Pay" to submit.</b>
            {feeDue && configurations.activePayProcessor == "authorize" && <PaymentForm amount={feeDue} isModal={true} />}
          </Col>
        </Row>
          <Row>
          <Col>
            {configurations.activePayProcessor != "authorize" && (
              <CleanButton loading={paymentTokenLoading || paymentLoader} icon="check-double" onClick={() => handleContinue(feeDue, moneyInCode)}>
                Pay and Submit E-File
              </CleanButton>
            )}
          </Col>
          <Col>
            <CleanButton onClick={() => setIsModalVisible(false)} icon="times">
              Cancel
            </CleanButton>
          </Col>
        </Row>
      </Content>
    </Page>
  );
};

export default CivilEFilePayment;
